import React, { useRef, useState } from 'react';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import { ModalTypes } from '@components/Modal/Modal';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import { ROUTES } from '../../constants';
import { openModalType } from '../../store/ui';
import {
    Description,
    Label,
    Login,
    Registration,
    RegistrationBenefits,
    RegistrationBenefitsAnswer,
    RegistrationBenefitsAnswerIcon,
    RegistrationBenefitsQuestion,
    Wrapper,
} from './Login.elements';

export interface LoginProps {}

const LoginTemplate: FC<LoginProps> = () => {
    const { t } = useTranslations();
    const router = useRouter();
    const dispatch = useDispatch();

    return (
        <Wrapper>
            <Login>
                <Label>{t('shop.login.label')}</Label>
                <Description>{t('shop.login.description')}</Description>
                <ButtonTemplate
                    onClick={() =>
                        dispatch(
                            openModalType({
                                type: ModalTypes.LOGIN,
                            })
                        )
                    }
                    marginTop={20}
                    marginBottom={40}
                    text={t('shop.login.account.login')}
                />
            </Login>
            <Registration>
                <Label>{t('shop.registration.label')}</Label>
                <ButtonTemplate
                    onClick={() => router.push({ pathname: ROUTES.REGISTER })}
                    marginTop={30}
                    marginBottom={30}
                    text={t('shop.login.account.register')}
                />
                <RegistrationBenefits>
                    <RegistrationBenefitsQuestion>{t('shop.registration.question')}</RegistrationBenefitsQuestion>
                    <RegistrationBenefitsAnswer>
                        <RegistrationBenefitsAnswerIcon name={Icons.CheckThin} />
                        {t('shop.registration.benefit1')}
                    </RegistrationBenefitsAnswer>
                    <RegistrationBenefitsAnswer>
                        <RegistrationBenefitsAnswerIcon name={Icons.CheckThin} />
                        {t('shop.registration.benefit2')}
                    </RegistrationBenefitsAnswer>
                    <RegistrationBenefitsAnswer>
                        <RegistrationBenefitsAnswerIcon name={Icons.CheckThin} />
                        {t('shop.registration.benefit3')}
                    </RegistrationBenefitsAnswer>
                    <RegistrationBenefitsAnswer>
                        <RegistrationBenefitsAnswerIcon name={Icons.CheckThin} />
                        {t('shop.registration.benefit4')}
                    </RegistrationBenefitsAnswer>
                </RegistrationBenefits>
            </Registration>
        </Wrapper>
    );
};

export default LoginTemplate;
